import { Outlet } from 'react-router';
import { Hreflang } from '@components/seo/Hreflang';
import { AdminHeader } from '@layouts/admin-layout/admin-header/AdminHeader';
import ErrorBoundary from '@components/error-boundary/ErrorBoundary';



export const AdminLayout = () => {

	return (
		<ErrorBoundary>
			
			<div className="app-admin-layout">

				<Hreflang />

				<AdminHeader />
				
				<Outlet />

			</div>
		
		</ErrorBoundary>
	);
};